import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ToasterService } from 'app/services/user-interaction/services/toaster.service';
import * as L from 'leaflet';
import 'leaflet-draw';
import { BaseFormComponent } from '../../../base-form.component';
import { SimulationContainerFormComponent } from '../container-form/container-form.component';

const iconUrl = 'assets/img/marker-icon.png';
const Defaulticon = L.icon({
    iconUrl,
    iconSize: [25, 25],
    iconAnchor: [5, 20],
    popupAnchor: [1, -34],
    tooltipAnchor: [16, -28]
});
const ContainerFormIcon = L.Icon.extend({
    options: {
        iconSize: [25, 25],
        iconAnchor: [5, 20],
        popupAnchor: [1, -34],
        tooltipAnchor: [16, -28]
    }
})
L.Marker.prototype.options.icon = Defaulticon;

@Component({
    selector: 'app-container-location-form',
    templateUrl: './container-location-form.component.html',
    styleUrls: ['./container-location-form.component.scss']
})
export class SimulationContainerLocationFormComponent extends BaseFormComponent implements OnInit {
    private map;
    public myLocation: L.LatLng = L.latLng(0, 0);
    public selectedLocation: L.LatLng;
    public markerOpen = false;
    constructor(
        public dialogRef: MatDialogRef<SimulationContainerFormComponent>,
        public _translateService:TranslateService,
        @Inject(MAT_DIALOG_DATA) public data,
        public _toastService: ToasterService
    ) {
        super();
    }

    ngOnInit(): void {
        this.initMap();
    }


    public get MapTileUrl(): string {
        return 'http://tile.openstreetmap.org/{z}/{x}/{y}.png';
    }

    private async initMap(): Promise<void> {
        var options = {
            enableHighAccuracy: true,
            timeout: 10000,
            maximumAge: 5000
        };
        this.myLocation
        navigator.geolocation.getCurrentPosition(position => {

            this.myLocation = new L.LatLng(position.coords.latitude, position.coords.longitude)
        },
            ()=> {
                return this._toastService.toastFail(this._translateService.instant("DEVICE_LOCATION_INFORMATION_COULD_NOT_BE_OBTAINED"))
            },
            {
                enableHighAccuracy: true,
                timeout: 10000,
                maximumAge: 5000
            }
        );

        this.map = L.map('map', {
            center: [39.09766, 34.56039],
            zoom: 8
        });
        const tiles = L.tileLayer(
            this.MapTileUrl, {
            maxZoom: 19,
            minZoom: 5,
            attribution: 'AKILLI-ATIK-SİSTEMİ'
        });
        tiles.addTo(this.map);

        setTimeout(() => {
            const marker = L.marker([this.myLocation.lat, this.myLocation.lng], {
                icon: new ContainerFormIcon({ iconUrl: 'assets/img/marker.png' })
            });
            marker.addTo(this.map)
            this.map.flyTo(new L.LatLng(this.myLocation.lat, this.myLocation.lng), 19)
        }, 1000)
        this.map.on("click", async e => {
            if (this.markerOpen == true) {
                this.selectedLocation = e.latlng;
                this.dialogRef.close(this.selectedLocation)
            }

        });

    }

    public onUpdateLocationClick(e) {
        this.markerOpen = true;
        this._toastService.toastWarning(this._translateService.instant("MARKING_IS_ACTIVE_PLEASE_MARK_A_LOCATION_ON_THE_MAP"));
        e.stopPropagation();
    }

    public onAddLocationClick(e) {
        this.selectedLocation = new L.LatLng(this.myLocation.lat, this.myLocation.lng)
        this.dialogRef.close(this.selectedLocation)
        e.stopPropagation();
    }

    public onCancelLocationClick(e) {
        this.markerOpen = false;
        this._toastService.toastFail(this._translateService.instant("MARKING_IS_PASSIVE"));
        e.stopPropagation()
    }

}
